module.exports = __webpack_public_path__ + "static/kenku-52cd3a4418ee6bb56baca3519ae9b41e.jpg";